import { postFetch } from '../fetch';

import { apiConfig } from '../config';

export function deleteClass(classId: any) {
    const { apiDeleteClass } = apiConfig.getStaticUrls();

    return postFetch(`${apiDeleteClass}${classId}/`);
}
